import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerDialogComponent } from './color-picker-dialog.component';
import { AppMaterialModule } from '../../../app/app-material/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
@NgModule({
  declarations: [ColorPickerDialogComponent],
  imports: [
    AppMaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule
  ]
})
export class ColorPickerDialogModule {}
